import { portraitYears, timelinePortraits } from "../portrait_years";

portraitYears(document.querySelector("[data-portrait-main]"));
timelinePortraits(document.querySelector(".timeline[data-portrait-years]"));
